import { create } from "zustand";

export const InitialPageStore = create((set) => ({
  prodAgropecImage: null,
  mapImage: null,

  imovelImage: null,

  setImovelImage: (img) => {
    set({ imovelImage: img });
  },

  setProdAgropecImage: (img) => set({ prodAgropecImage: img }),
  setMapImage: (img) => set({ mapImage: img }),
}));
